import {defineMessages} from "@project/i18n";

export const offerHistoryMessages = defineMessages({
  title: {
    id: "sales.offers.history.title",
    defaultMessage: "History",
    description: "Previous revisions tab",
  },
  table: {
    id: "sales.offers.history.table",
    defaultMessage: "Previous Offer revisions",
    description: "Read-only revision history table",
  },
  empty: {
    id: "sales.offers.history.empty",
    defaultMessage: "No previous revisions",
    description: "Actual predecessor chain is empty",
  },
  failed: {
    id: "sales.offers.history.failed",
    defaultMessage: "Could not load the complete revision history.",
    description:
      "Read failure or invalid predecessor chain; never present partial history as complete",
  },
  retry: {
    id: "sales.offers.history.retry",
    defaultMessage: "Retry",
    description: "Retry public history reads",
  },
  number: {
    id: "sales.offers.history.number",
    defaultMessage: "Offer",
    description: "Revision display number",
  },
  version: {
    id: "sales.offers.history.version",
    defaultMessage: "Revision",
    description: "Revision version column",
  },
  status: {
    id: "sales.offers.history.status",
    defaultMessage: "Status",
    description: "Revision status",
  },
  language: {
    id: "sales.offers.history.language",
    defaultMessage: "Language",
    description: "Revision language",
  },
  currency: {
    id: "sales.offers.history.currency",
    defaultMessage: "Currency",
    description: "Revision Currency",
  },
  actions: {
    id: "sales.offers.history.actions",
    defaultMessage: "Actions",
    description: "Read-only revision actions",
  },
  preview: {
    id: "sales.offers.history.preview",
    defaultMessage: "Preview Offer",
    description: "Preview the selected previous revision",
  },
});
